<template>
    <div class="modal" >
        <div class="modal-content">
            <div class="modal-header">
               Voorwaarden  <button class="btn btn-info btn-sm" @click="closeModal">X</button>
            </div>
  
            <div class="modal-body">
                    
                1. Gertrude is een activiteit van Right Lane Productions, hierna te noemen RL.<br>
                2. RL zal de privacy van de gebruiker respecteren. <br>
                3. RL zal de geuploade tekst niet publiceren, niet in gedrukte vorm en niet via internet. De tekst zal niet met derden worden gedeeld. <br>
                4. De gebruiker verklaart dat de door haar/hem aangeleverde tekst zelf is vervaardigd en niet is overgenomen van een ander.<br>
                5. Indien de gebruiker een e-mailadres opgeeft voor aankoop van het analyserapport, wordt dit voor geen andere doeleinden door RL benut dan voor de verzending van het analyserapport.<br>
                6. De classificatie door Gertrude gebeurt anoniem. Door aanleveren van een tekst levert de gebruiker geen persoonsgegevens aan.<br>
                7. Indien de gebruiker tot aankoop overgaat van het analyserapport, levert de gebruiker een e-mailadres. Het gaat hierbij om een doelverstrekking in de zin van Artikel 6, Rechtmatigheid van de verwerking van de AVG: de verwerking is noodzakelijk voor de uitvoering van een overeenkomst waarbij de betrokkene partij is.<br>
                8. RL mag de aangeleverde tekst gebruiken voor onderzoek en ontwikkeling van het systeem Gertrude.<br>
                9. RL neemt gebruikelijke maatregelen om de geheimhouding van de aangeleverde tekst en aangeleverd e-mailadres te verzekeren. RL is gevrijwaard van financiële claims en juridische vervolging als RL niet aan geheimhouding kan voldoen als gevolg van hacking en/of andere criminaliteit.<br>
                10. RL is op geen enkele wijze financieel aansprakelijk naar aanleiding van de verleende diensten.
                            
            </div>
            <hr>
            <div class="modal-footer">
                <button class="btn btn-info btn-sm" @click="closeModal">X</button>
            </div>
        </div>
    </div>
</template>
<script>
//https://www.genuitec.com/beginners-guide-to-vue-modals/
  export default {
    name: 'app-modal',
    props: {
        showModal: Boolean
    },
    methods: {
        closeModal() {
            this.$emit('clicked');
        }
    },
  };
</script>
<style>
    .modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 700px;
        max-width: 100%;
        background: #FFF;
        overflow-x: auto;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
    }
    .modal-header{
       color:#000;
       font-size:1.5em;
    }
    .modal-body{
        color:#000;
        text-align:left;
        font-size: 0.9em;

    }


</style>